export var BASE_URL = "https://api-search.faceapp.io:443";
export var appName = "FaceApp";
export var appVersion = "3.3.8";
export var deviceModel = "iPhone XS Max (China)";
export var systemVersion = "12.2";
export var deviceType = "iPhone11,6";
export var UA = "".concat(appName, "/").concat(appVersion, " (").concat(deviceModel, "; ").concat(deviceType, "; iOS Version ").concat(systemVersion, " (Build 16E227); Scale/3.0)");
export var FACE_CELE_PATH = "/api/v1.1/search/photos/celebrities";
export var FACE_PHOTO_PATH = "/api/v1.1/search/photos";